// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3kQXq","col":"styles_col__rKjh4"};